// enci.minioUtils.js
import CustomStore from "devextreme/data/custom_store";
import { getApiUrl } from "./enci.config.js";
import { debugLog } from './enci.log.js';
// import { tokenManager } from './enci.tokenManager.js';

/**
 * Sets the Minio data source for a form widget's image field.
 * @param {Object} formWidget - The form widget to modify
 * @param {string} formImageField - The name of the image field
 * @param {string} bucket - The Minio bucket name
 * @param {string} prefix - The prefix for Minio objects
 */
export const setMinioDataSource = (formWidget, formImageField, bucket, prefix) => {
  formWidget.itemOption(formImageField, 'editorOptions', {
    dataSource: createMinioDataSource(bucket, prefix),
  });
};

/**
 * Creates a custom data store for Minio objects.
 * @param {string} bucketName - The name of the Minio bucket
 * @param {string} prefix - The prefix for Minio objects
 * @returns {CustomStore} A CustomStore instance for Minio data
 */
export const createMinioDataSource = (bucketName, prefix) => {
  return new CustomStore({
    key: 'key',
    load: async () => {
      try {
        // const accessToken = await tokenManager.getToken();
        const response = await fetch(
          `${getApiUrl()}/Minio/ListObjects/${bucketName}?recursive=false&prefix=${prefix}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              // Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
      } catch (error) {
        debugLog('Error in Minio data source load:', { obj: error, type: 'error' });
        throw new Error('Data Loading Error');
      }
    },
    byKey: key => {
      debugLog('Minio data source >> key:', { obj: key });
      // Implement if needed
    },
  });
};
